import Forgot from "./ForgotPassword";
export default Forgot;
